import { Stack } from "@mui/system";
import { DishAllergen, DishResponse } from "api-types";

import React, { useCallback } from "react";

import { Box, Typography, useTheme } from "@mui/material";

import { NotInterestedRounded } from "@mui/icons-material";

import { AllergenChipOutlined } from "../../Chip/Chip";
import { DynamicDrawer } from "../../Drawer/DynamicDrawer";
import CloseIcon from "../../Icons/Close";

interface AllergenIngredientsDrawerProps {
  dish: DishResponse;
  matchedAllergens: DishAllergen[];
  open: boolean;
  containerRef?: React.RefObject<HTMLDivElement>;
  onClose?: () => void;
}

export const AllergenIngredientsDrawer = ({
  dish,
  open,
  onClose,
  matchedAllergens,
  containerRef,
}: AllergenIngredientsDrawerProps) => {
  const theme = useTheme();
  const { oscar } = theme.palette;

  const getIngredients = useCallback(
    (allergen: DishAllergen) => {
      return dish.ingredients
        ?.filter((i) =>
          i.igfdTaxAllergenIds?.includes(allergen.igfdTaxAllergenId)
        )
        .map((i) => i.ingredientName)
        .join(", ");
    },
    [dish.ingredients]
  );

  return (
    <DynamicDrawer
      ref={containerRef}
      drawerType="small"
      open={open}
      onClose={onClose}
      Header={
        <Stack alignItems="center" justifyItems="flex-start" gap={1}>
          <Stack flexDirection="row" alignItems="center" gap={1}>
            <NotInterestedRounded
              fontSize="small"
              sx={{
                color: oscar.light.icon.danger,
                fontSize: 20,
              }}
            />
          </Stack>
          <Typography
            color={oscar.light.icon.danger}
            variant="headingRLight"
            textAlign="center"
          >
            Allergies
          </Typography>
        </Stack>
      }
      Footer={
        <CloseIcon
          color={oscar.light.icon.black}
          style={{ cursor: "pointer" }}
          height={32}
          width={32}
          onClick={onClose}
        />
      }
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap={4}
        marginTop={4}
        width="100%"
      >
        {matchedAllergens?.map((allergen) => {
          const ingredients = getIngredients(allergen);
          return (
            <Box
              key={allergen.igfdTaxAllergenId}
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              gap={1}
            >
              <AllergenChipOutlined allergenName={allergen.allergenName} />
              <Typography
                color={oscar.light.content.content1}
                variant="labelXSLight"
                textAlign="left"
              >
                {ingredients}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </DynamicDrawer>
  );
};
